const currencyToLocaleMap = {
  USD: "en-US",
  AUD: "en-AU",
  CAD: "en-CA",
  EUR: "en-IE",
  GBP: "en-GB",
};

const dollarCurrencies = ["USD", "AUD", "CAD", "NZD"];

const parseCurrencyString = (currencyString: string) => {
  const cleanedString = currencyString.replace(/[^\d.-]/g, "");
  return parseFloat(cleanedString);
};

export const formatAmountForDisplay = (
  amount: number | string,
  currency = "",
  showCurrencySuffix = true,
  stripZeros = false
) => {
  const locale = currencyToLocaleMap[currency] || "en-US";
  const amountNumber = typeof amount === "string" ? parseCurrencyString(amount) : amount;
  const formattedAmount = new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    trailingZeroDisplay: stripZeros ? "stripIfInteger" : "auto",
  }).format(amountNumber);
  return dollarCurrencies.includes(currency) && showCurrencySuffix ? `${formattedAmount} ${currency}` : formattedAmount;
};
